;(function ($) {


    // Header-bar auto-pinning

    // Always-pinned on black friday homepage
    if ($('body').hasClass('page-home--blackFriday')) {
        $('body').addClass('header-pinned')
        return
    }


    var scrollTreshold = 450
    var body = $('body')

    function setHeaderType() {
        var scrollPosition = $(window).scrollTop()

        if (scrollPosition > scrollTreshold) {
            body.addClass('header-pinned')
        }
        else {
            body.removeClass('header-pinned')
        }
    }

    function setScrollUp() {
        var scrollPosition = $(window).scrollTop()

        if (scrollPosition > scrollTreshold) {
            body.addClass('scrollUp-pinned')
        }
        else {
            body.removeClass('scrollUp-pinned')
        }
    }


    setHeaderType()
    $(window).scroll(function () {
        setHeaderType()
    })


})(jQuery);
